import { createContext, useContext, useState, ReactNode } from 'react'
import { NotificationItem } from 'utils/notification-helpers'

interface NotificationsContextValue {
	latestWsNotification: NotificationItem | null
	setLatestWsNotification: (n: NotificationItem | null) => void
}

const NotificationsContext = createContext<NotificationsContextValue>({
	latestWsNotification: null,
	setLatestWsNotification: () => {},
})

export function NotificationsProvider({ children }: { children: ReactNode }) {
	const [latestWsNotification, setLatestWsNotification] = useState<NotificationItem | null>(null)
	return (
		<NotificationsContext.Provider value={{ latestWsNotification, setLatestWsNotification }}>
			{children}
		</NotificationsContext.Provider>
	)
}

export function useNotificationsContext() {
	return useContext(NotificationsContext)
}
